const MODAL_DATA_KEY = 'double11ModalData';

export type Double11ModalData = {
  date: string;
  count: number;
  lastShown: number;
};

/** 前端开关：不依赖活动配置接口 */
export const DOUBLE11_MODAL_ENABLED = true;

const getToday = () => new Date().toDateString();

export const getDouble11ModalData = (): Double11ModalData => {
  try {
    const raw = localStorage.getItem(MODAL_DATA_KEY);
    if (raw) {
      return JSON.parse(raw);
    }
  } catch {
    // ignore
  }
  return { date: '', count: 0, lastShown: 0 };
};

export const saveDouble11ModalOnClose = (): void => {
  const today = getToday();
  const now = Date.now();
  const modalData = getDouble11ModalData();
  const newData: Double11ModalData = {
    date: today,
    count: (modalData.date === today ? modalData.count : 0) + 1,
    lastShown: now,
  };
  localStorage.setItem(MODAL_DATA_KEY, JSON.stringify(newData));
};

/** 每天最多 3 次，间隔至少 2 小时 */
export const shouldShowDouble11Modal = (): boolean => {
  if (!DOUBLE11_MODAL_ENABLED) {
    return false;
  }

  const today = getToday();
  const now = Date.now();
  const modalData = getDouble11ModalData();

  if (modalData.date !== today) {
    localStorage.setItem(
      MODAL_DATA_KEY,
      JSON.stringify({ date: today, count: 0, lastShown: 0 }),
    );
    return true;
  }

  const hoursSinceLastShown =
    (now - (modalData.lastShown || 0)) / (1000 * 60 * 60);
  return modalData.count < 3 && hoursSinceLastShown >= 2;
};
